import ReactDOM from 'react-dom/client';

// O handoff do token da URL (public/index.html) sai do window na avaliação deste módulo.
// Importar aqui prende essa avaliação ao entry: um lazy nas rotas rebaixaria a leitura para
// quando o chunk carregar, sem quebrar teste nenhum.
import './auth/querySessionTokens';
// O mesmo para o token do link sem login do portal do assinante.
import './utils/subscriberLinkToken';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

serviceWorkerRegistration.unregister();
reportWebVitals();
